// =============================================================================
// SIREPPAR - Bloque de "Atributos objetados" dentro del cuerpo de un informe
// =============================================================================
// Reutilizado por los modales Informe al Secretario e Informe al TEP: al tildar
// atributos objetados, se agrega/actualiza un bloque gestionado al final del
// cuerpo del informe. El resto del texto se edita libremente; este bloque se
// reconstruye (idempotente) en cada cambio de selección.
//
// El armado/quitado del bloque lo hace bloquesInforme.ts, que además preserva
// los otros bloques gestionados (p. ej. "Antecedentes") si el modal usa los dos.
// =============================================================================

import { MARKER_OBJETADOS, aplicarBloqueGestionado } from './bloquesInforme';

export { MARKER_OBJETADOS };

export const LABELS_ATRIBUTOS: Record<string, string> = {
  DENOMINACION: 'Denominación (nombre)',
  SIGLA: 'Sigla',
  COLOR: 'Colores',
  SIMBOLO: 'Símbolo',
};

export function bloqueObjetados(attrs: string[]): string {
  if (attrs.length === 0) return '';
  return `${MARKER_OBJETADOS}\n${attrs.map((a) => `- ${LABELS_ATRIBUTOS[a] || a}`).join('\n')}`;
}

export function aplicarObjetados(attrs: string[], cuerpoActual: string): string {
  return aplicarBloqueGestionado(cuerpoActual, MARKER_OBJETADOS, bloqueObjetados(attrs));
}
